import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import AlchemyTimeline from '@/components/ChartTypes/AlchemyTimeline'
import { Paper } from 'material-ui'

const styles = theme => ({
  paperCalendarView: {
    margin: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  }
})

@withStyles(styles)
export default class Timeline extends Component {
  render() {
    const { classes } = this.props
    return (
      <div>
        <div>
          <Paper className={classes.paperCalendarView}>
            <AlchemyTimeline />
          </Paper>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/timeline.js